import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private TOKEN_KEY = 'authToken';

  // Save JWT Token
  saveToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  // Get JWT Token
  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  // Remove JWT Token
  removeToken(): void {
    localStorage.removeItem(this.TOKEN_KEY);
  }

  // Check if Token Exists
  isLoggedIn(): boolean {
    return !!this.getToken();
  }
}
